import { render, staticRenderFns } from "./deal-events-table.vue?vue&type=template&id=714db364&scoped=true&"
import script from "./deal-events-table.vue?vue&type=script&lang=js&"
export * from "./deal-events-table.vue?vue&type=script&lang=js&"
import style0 from "./deal-events-table.vue?vue&type=style&index=0&id=714db364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714db364",
  null
  
)

export default component.exports